import { ORDER_FULFILLMENT_STATUSES } from '../../../../../services/exports/Constants';

export default {
  title: 'Szacowany {{orderMethod}}: {{day}} około {{time}}',
  status: {
    [ORDER_FULFILLMENT_STATUSES.REJECTED]: {
      title: 'Zamówienie odrzucone',
    },
    [ORDER_FULFILLMENT_STATUSES.CREATED]: {
      title: 'Zamówienie otrzymane',
    },
    [ORDER_FULFILLMENT_STATUSES.REVIEWED]: {
      title: 'Twoje zamówienie zostało zauważone',
    },
    [ORDER_FULFILLMENT_STATUSES.ACCEPTED]: {
      title: 'Zamówienie potwierdzone',
    },
    [ORDER_FULFILLMENT_STATUSES.READY]: {
      title: 'Zamówienie gotowe',
    },
    [ORDER_FULFILLMENT_STATUSES.ON_DELIVERY]: {
      title: 'Zamówienie w drodze',
    },
    [ORDER_FULFILLMENT_STATUSES.PICKED]: {
      title: 'Zamówienie zrealizowane',
    },
  },
  labels: {
    today: 'Dzisiaj',
  },
  waiting_confirmation: {
    title: 'Oczekiwanie na potwierdzenie',
    description: 'Chwileczkę...',
  },
  pickup_time: {
    title: 'Czas odbioru',
    description: 'Potwierdzone przez {{name}}',
  },
  delivery_time: {
    title: 'Czas dostawy',
    description: 'Potwierdzone przez {{name}}',
  },
  warning_label: {
    pickup_time_changed: '{{company}} zmieniło czas z {{initialTime}} na {{currentTime}}',
  },
};
